// Moment format strings shared app-wide. API formats are what the backend accepts and returns;
// display formats are what the user sees.
export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_DISPLAY_FORMAT = 'MM/DD/YYYY';
export const DATE_TIME_DISPLAY_FORMAT = `${DATE_DISPLAY_FORMAT} hh:mm A`;
export const MONTH_YEAR_DISPLAY_FORMAT = 'MM/YYYY';
